import { createFileRoute } from '@tanstack/react-router';

import { SupplierQuotesPage } from '@/features/supplier/quotes-page';

export const Route = createFileRoute('/_app/supplier/$orgId/quotes')({
  component: RouteComponent,
});

function RouteComponent() {
  const params = Route.useParams();
  return <SupplierQuotesPage {...params} />;
}
